// src/utils/apiError.js
// Centralized API error handler — extracts a clean message from any axios error.

/**
 * Extract a user-friendly message from an axios error.
 */
export const getErrorMessage = (error) => {
  if (!error) return 'Something went wrong. Please try again.';
  if (error.response?.data?.message) return error.response.data.message;
  if (error.response?.data?.msg) return error.response.data.msg;
  if (error.response?.data?.error) return error.response.data.error;
  if (error.message) return error.message;
  return 'Something went wrong. Please try again.';
};

/**
 * Returns true if the error requires a plan upgrade.
 */
export const isUpgradeRequired = (error) => {
  if (error?.response?.status === 403) return true;
  if (error?.response?.data?.requiresUpgrade) return true;
  const msg = getErrorMessage(error).toLowerCase();
  return msg.includes('upgrade') || msg.includes('premium') || msg.includes('plan');
};

/**
 * Handles an API error: redirects on 401, opens upgrade modal on 403/upgrade,
 * otherwise sets a user-friendly error message.
 */
export const handleApiError = (error, setError, openUpgrade) => {
  if (error?.response?.status === 401) {
    window.location.href = '/goldpetals/login';
    return;
  }
  if (isUpgradeRequired(error) && typeof openUpgrade === 'function') {
    openUpgrade();
    return;
  }
  if (typeof setError === 'function') {
    setError(getErrorMessage(error));
  }
};
